// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screenshotPdfFooter--GB5CZ {
  height: 120px;
  color: black;
  display: flex;
  position: relative;
}[dir] .screenshotPdfFooter--GB5CZ {
  background: #f5f5f5;
}

.screenshotPdfFooterCopyright--nWj2B {
  line-height: 120px;
  color: #343c42;
  width: 50%;
  display: flex;
  justify-content: flex-end;
}

[dir=ltr] .screenshotPdfFooterCopyright--nWj2B {
  padding-right: 30px;
}

[dir=rtl] .screenshotPdfFooterCopyright--nWj2B {
  padding-left: 30px;
}

.screenshotPdfFooterTextWrapper--z0ng3 {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

[dir] .screenshotPdfFooterTextWrapper--z0ng3 {
  padding: 0 15px;
}

[dir=ltr] .screenshotPdfFooterTextWrapper--z0ng3 {
  left: 0;
}

[dir=rtl] .screenshotPdfFooterTextWrapper--z0ng3 {
  right: 0;
}

.screenshotPdfFooterText--W_lSW {
  display: inline-block;
  color: #343c42;
}

[dir] .screenshotPdfFooterText--W_lSW {
  margin: 0;
}

[dir] .screenshotPdfFooterDevider--bluSD {
  margin: 0 5px;
}

.screenshotPdfFooterLink--MeB1U {
  display: inline-block;
  color: #113e86;
}

.screenshotPdfFooterLogoWrapper--YCL_A {
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: flex-start;
}

[dir=ltr] .screenshotPdfFooterLogoWrapper--YCL_A {
  padding-left: 30px;
}

[dir=rtl] .screenshotPdfFooterLogoWrapper--YCL_A {
  padding-right: 30px;
}

.screenshotPdfFooterLogo--j5TxB {
  width: 175px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/ScreenshotFooter/styles.css"],"names":[],"mappings":"AAAA;EAEE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB,CANA;EACE,mBAAmB;AAKrB;;AAEA;EAEE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAPA;EACE,mBAAmB;AAMrB;;AAPA;EACE,kBAAmB;AAMrB;;AAEA;EACE,OAAO;EAEP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EAEN,WAAW;EACX,YAAY;AACd;;AAXA;EAEE,eAAe;AASjB;;AAXA;EAQE,OAAO;AAGT;;AAXA;EAQE,QAAO;AAGT;;AAEA;EACE,qBAAqB;EAErB,cAAc;AAChB;;AAJA;EAEE,SAAS;AAEX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EAEnB,UAAU;EACV,2BAA2B;AAC7B;;AANA;EAGE,kBAAkB;AAGpB;;AANA;EAGE,mBAAkB;AAGpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":[".screenshotPdfFooter {\n  background: #f5f5f5;\n  height: 120px;\n  color: black;\n  display: flex;\n  position: relative;\n}\n\n.screenshotPdfFooterCopyright {\n  padding-right: 30px;\n  line-height: 120px;\n  color: #343c42;\n  width: 50%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.screenshotPdfFooterTextWrapper {\n  flex: 1;\n  padding: 0 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.screenshotPdfFooterText {\n  display: inline-block;\n  margin: 0;\n  color: #343c42;\n}\n\n.screenshotPdfFooterDevider {\n  margin: 0 5px;\n}\n\n.screenshotPdfFooterLink {\n  display: inline-block;\n  color: #113e86;\n}\n\n.screenshotPdfFooterLogoWrapper {\n  display: flex;\n  align-items: center;\n  padding-left: 30px;\n  width: 50%;\n  justify-content: flex-start;\n}\n\n.screenshotPdfFooterLogo {\n  width: 175px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screenshotPdfFooter": `screenshotPdfFooter--GB5CZ`,
	"screenshotPdfFooterCopyright": `screenshotPdfFooterCopyright--nWj2B`,
	"screenshotPdfFooterTextWrapper": `screenshotPdfFooterTextWrapper--z0ng3`,
	"screenshotPdfFooterText": `screenshotPdfFooterText--W_lSW`,
	"screenshotPdfFooterDevider": `screenshotPdfFooterDevider--bluSD`,
	"screenshotPdfFooterLink": `screenshotPdfFooterLink--MeB1U`,
	"screenshotPdfFooterLogoWrapper": `screenshotPdfFooterLogoWrapper--YCL_A`,
	"screenshotPdfFooterLogo": `screenshotPdfFooterLogo--j5TxB`
};
export default ___CSS_LOADER_EXPORT___;
